export const SAO_CUNG_MENH = [
  {
    id: 0,
    name: '',
    des: ''
  },
  {
    id: 1,
    name: 'Thiên Quý',
    des: 'Chí khí bất phàm, làm việc thong thả, tự do an nhàn, vạn sự đều thông'
  },
  {
    id: 2,
    name: 'Thiên Ách',
    des: 'Mưu sự trì trệ, cuộc sống lao khổ, mang bệnh tật kéo dài, gây chuyện thị phi'
  },
  {
    id: 3,
    name: 'Thiên Quyền',
    des: 'Thông minh phú quý, được người tôn sùng, trung niên có quyền, thanh cao ổn trọng'
  },
  {
    id: 4,
    name: 'Thiên Phá',
    des: 'Phá bại hao tán, khảng khái khinh tài, trong ân lấy oán, thân bằng khó dựa'
  },
  {
    id: 5,
    name: 'Thiên Gian',
    des: 'Cơ mưu linh động, nhiều việc phản phục, gian trá đa đoan, trong ngoài không thống nhất'
  },
  {
    id: 6,
    name: 'Thiên Văn',
    des: 'Thông minh linh lợi, văn chương chấn phát, làm việc khéo léo, danh lợi hiển đạt'
  },
  {
    id: 7,
    name: 'Thiên Phúc',
    des: 'Vinh hoa cát lợi, tài lộc phong hậu, hiền lương ôn nhã, phú quý song toàn'
  },
  {
    id: 8,
    name: 'Thiên Dịch',
    des: 'Tay trắng khởi nghiệp, nên xa mới an, bôn ba lao lục, lục thân không có nương tựa'
  },
  {
    id: 9,
    name: 'Thiên Cô',
    des: 'Bôn ba không nơi nương tựa, lục thân quay mặt, hình phu khắc tử, cô khổ vô y'
  },
  {
    id: 10,
    name: 'Thiên Nhận',
    des: 'Tính tình cương trực, tranh cường háo thắng, việc làm không có gốc, lại sợ thị phi'
  },
  {
    id: 11,
    name: 'Thiên Nghệ',
    des: 'Thông minh tú khí, nghệ đạo có danh, cơ động linh mưu, cả đời có quý'
  },
  {
    id: 12,
    name: 'Thiên Thọ',
    des: 'Tâm từ thông minh, làm việc công bình, tự kiềm chế hay giúp người, sống thọ'
  }
]
